import React, { useEffect, useState } from 'react'
import { getData, putData } from '../global/Globalapi'
import Productpage from './Productpage'
import Step4 from '../Components/DynamicComp/Step4'
import Modal from '../Components/DynamicComp/modal'
import { encodeId } from '../global/Globalfunction'
import swal from 'sweetalert';
const Manageproduct = () => {
    const [product,setproduct]=useState([])
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentFeature, setCurrentFeature] = useState(null);
      const [activeTab, setActiveTab] = useState('Approved');
   const [features, setFeatures] = useState({
    FeatureProduct: false,
    NewProduct: false,
    Status: null,
  })
  const [showFeaturedOnly, setShowFeaturedOnly] = useState(false);
  const allProductsOff =
  product.length > 0 &&
  product.every(p => p.product_stage === "Rejected");

const allProductsOn =
  product.length > 0 &&
  product.every(p => p.product_stage === "Approved");
// const toggleAllProducts = async () => {
//   const isTurningOn = allProductsOff; // if all OFF → turn ON
//   const nextStatus = isTurningOn ? "Approved" : "Rejected";

//   const label = isTurningOn ? "ON" : "OFF";

//   if (!window.confirm(`Are you sure you want to turn ${label} all products?`))
//     return;

//   try {
//     await Promise.all(
//       product.map((p) =>
//         putData(`/updateproductfeatures/${p.product_id}`, {
//           Status: nextStatus,
//           FeatureProduct: false,
//           NewProduct: false,
//         })
//       )
//     );

//     alert(`All products turned ${label} successfully`);
//     fetch();
//     setActiveTab(nextStatus); // optional UX polish
//   } catch (err) {
//     console.error(err);
//     alert(`Failed to turn ${label} all products`);
//   }
// };
const toggleAllProducts = async () => {
  const isTurningOn = allProductsOff; // if all OFF → turn ON
  const nextStatus = isTurningOn ? "Approved" : "Rejected";
  const label = isTurningOn ? "ON" : "OFF";

  // 🔔 Replace window.confirm
  const confirmed = await swal({
    title: "Are you sure?",
    text: `Are you sure you want to turn ${label} all products?`,
    icon: "warning",
    buttons: ["Cancel", `Yes, turn ${label}`],
    dangerMode: true,
  });

  if (!confirmed) return;

  try {
    await Promise.all(
      product.map((p) =>
        putData(`/updateproductfeatures/${p.product_id}`, {
          Status: nextStatus,
          FeatureProduct: false,
          NewProduct: false,
        })
      )
    );

    // ✅ Replace alert success
    swal("Success", `All products turned ${label} successfully`, "success");

    fetch();
    setActiveTab(nextStatus); // optional UX polish
  } catch (err) {
    console.error(err);

    // ❌ Replace alert error
    swal("Error", `Failed to turn ${label} all products`, "error");
  }
};
  const initializeFeaturesFromProduct = (product) => {
  setFeatures({
    FeatureProduct: product.Feature_product === 1 || product.FeatureProduct === true,
    NewProduct: product.New_Product === 1 || product.NewProduct === true,
    Status: product.product_stage,
  });
};

    const fetch=async()=>{
        const res=await getData('/getmanageproduct');
        if(res.data){
            console.log(res);
            setproduct(res.data.result);
        }
    }
    useEffect(()=>{
        fetch();
    },[selectedProductId])
      const toggleFeature = (key) => {
    setFeatures((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }
  useEffect(()=>{
   console.log("features",features)
  },[features])
  const updateProductFeatures = async () => {
  if (!selectedProductId || !product) return;

  try {
    const selectedProduct = product.find(p => p.product_id === selectedProductId);
    const finalStatus = features.Status ?? selectedProduct.product_stage;
    console.log('product stage', finalStatus);
    const payload = {
      FeatureProduct: features.FeatureProduct,
      NewProduct: features.NewProduct,
      Status: finalStatus,
    };
    console.log('Updating features for product ID:',payload);

    const response = await putData(`/updateproductfeatures/${selectedProductId}`,payload);
     console.log('Features updated:', response.data);
    fetch();
  } catch (error) {
    console.error(' Error updating features:', error.message);
  }
};
useEffect(() => {
 console.log("selected product id",selectedProductId);
}, [selectedProductId]);

    const tabs = [
    // { key: 'review', label: 'review' },
    { key: 'Approved', label: 'ON' },
    { key: 'Rejected', label: 'OFF' },
  ];
 if ( selectedProductId) {
//   
  return (
    <div className="p-4 mt-4">
      {/* Step4 Product Preview Modal */}
      <Modal isOpen={true} onClose={async() =>{ await updateProductFeatures();
      setSelectedProductId(null)
      setFeatures({ FeatureProduct: false, NewProduct: false, Status: null });
  }} title="Product Preview"
        type="preview" 
     features={features} 
     setFeatures={setFeatures}
     onFeatureClick={(key) => { 
    if (key === 'Status') {
      setCurrentFeature(key);
      setIsModalOpen(true);
    } else {
      toggleFeature(key);
    }
  }}
        >
        <div className="!w-[90vw] sm:!w-[80vw] md:!w-[70vw] lg:!w-[60vw] xl:!w-[50vw] max-w-full max-h-[90vh] overflow-y-auto rounded-lg">
          {/* <Step4 id={selectedProductId} type="preview" /> */}
          <Step4 id={encodeId(selectedProductId)} type="preview" />
        </div>
      </Modal>

      {/* Status Selection Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Select Action for Status"
      >
        {/* <div className="flex justify-around mt-4">
          {['Approved', 'Rejected'].map((action) => (
            <button
              key={action}
              onClick={() => {
                setFeatures((prev) => ({
                  ...prev,
                  [currentFeature]: action,
                }));
                setIsModalOpen(false);
              }}
              className={`px-6 py-3 rounded-lg text-white font-semibold transition
                ${
                  action === 'Approved' || product.product_stage === 'Approved'
                    ? 'bg-green-600 hover:bg-green-700'
                    : 'bg-red-500 hover:bg-red-600'
                }`}
            >
              {action}
            </button>
          ))}
        </div> */}
        <div className="flex justify-around mt-4">
  {[
    { label: "ON", value: "Approved" },
    { label: "OFF", value: "Rejected" },
  ].map(({ label, value }) => (
    <button
      key={value}
      onClick={() => {
        setFeatures((prev) => ({
          ...prev,
          [currentFeature]: value,
        }));
        setIsModalOpen(false);
      }}
      className={`px-6 py-3 rounded-lg text-white font-semibold transition
        ${
          value === "Approved"
            ? "bg-green-600 hover:bg-green-700"
            : "bg-red-500 hover:bg-red-600"
        }`}
    >
      {label}
    </button>
  ))}
</div>
      </Modal>
    </div>
  );
  }
const filteredProducts = product
  .filter((item) => item.product_stage === activeTab)
  .filter((item) => {
    if (!showFeaturedOnly) return true;

    return item.Feature_product === 1 || item.FeatureProduct === true;
  });
return (
  <div className="flex flex-col h-screen bg-gray-50">
    <div className="bg-white shadow sticky top-0 z-10 px-4 py-3 border-b border-gray-200">
      <div className="flex flex-wrap items-center justify-between max-w-7xl mx-auto">
        <h2 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-0" style={{ color: 'var(--primary-text)' }}>
          Manage Products
        </h2>
        <div className="flex flex-wrap gap-2">
       
          {tabs.map((tab) => (
            
            <button
              key={tab.key}
              // onClick={() => setActiveTab(tab.key)}
              onClick={() => {
  setActiveTab(tab.key);
  setShowFeaturedOnly(false); // 🔥 reset featured filter
}}
              className={`px-4 py-2 rounded-full text-sm sm:text-base font-medium transition-all duration-300
                ${
                  activeTab === tab.key
                    ? 'bg-red-600 text-white shadow'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
            >
              {tab.label}
            </button>
            
          ))}
          {/* <button
  onClick={toggleAllProducts}
  className={`px-4 py-2 rounded-full font-semibold transition
    ${
      allProductsOff
        ? "bg-green-600 text-white hover:bg-green-700"
        : "bg-red-600 text-white hover:bg-red-700"
    }`}
>
  {allProductsOff ? "ON ALL" : "OFF ALL"}
</button> */}
   <button
  onClick={() => setShowFeaturedOnly(!showFeaturedOnly)}
  className={`px-4 py-2 rounded-full text-sm font-medium ${
    showFeaturedOnly
      ? "bg-red-500 text-white"
      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
  }`}
>
  
  FEATURED
</button>
        </div>
       {/* <button
  onClick={toggleAllProducts}
  className={`px-4 py-2 rounded-full font-semibold transition
    ${
      allProductsOff
        ? "bg-green-600 text-white hover:bg-green-700"
        : "bg-red-600 text-white hover:bg-red-700"
    }`}
>
  {allProductsOff ? "ON ALL" : "OFF ALL"}
</button> */}

      </div>
    </div>

    {/* Scrollable Product Section */}
    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        {/* <h1 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 capitalize">
        
          {activeTab === 'Approved'
    ? 'ON'
    : activeTab === 'Rejected'
    ? 'OFF'
    : activeTab}
        </h1> */}
        <h1 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 capitalize">
  {showFeaturedOnly
    ? 'FEATURED'
    : activeTab === 'Approved'
    ? 'ON'
    : activeTab === 'Rejected'
    ? 'OFF'
    : activeTab}
</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {/* {product
            .filter((product) => product.product_stage === activeTab)
            .map((product) => ( */}
            {filteredProducts.map((product) => (
              <Productpage
                key={product.product_id}
                product={product}
                onviewproduct={() => {setSelectedProductId(product.product_id)
                 initializeFeaturesFromProduct(product);
                }}
              />
            ))}
{/* 
          {product.filter((p) => p.product_stage === activeTab).length === 0 && (
            <div className="col-span-full text-center text-gray-500 text-base sm:text-lg">
              No products in this category.
            </div>
          )} */}
          {filteredProducts.length === 0 && (
  <div className="col-span-full text-center text-gray-500 text-base sm:text-lg">
    No products found.
  </div>
)}
        </div>
      </div>
    </div>
  </div>
)
}

export default Manageproduct
